<template>
    <div class="catalog-filter" ref="catalogFilterEl">
        <div class="item item--reset">
            <div class="item__top">
                <div class="item__title" @click="resetFilter">Сбросить фильтр</div>
                <div class="item__chevron" @click="closeFilter"><i class="termi-x"></i></div>
            </div>
        </div>
        <accordion class="item" :bodyShown="true" v-for="prop in properties" :key="prop.id">
            <template #toggler>
                <div class="item__top">
                    <div class="item__title">{{prop.title}}</div>
                    <i class="item__chevron termi-chevron-right"></i>
                </div>
            </template>
            <div class="item__body">
                <component
                    :is="(prop.search_type === 'between') ? 'v_between'
                    :(prop.search_type === 'check') ? 'v_checkboxes'
                    :(prop.search_type === 'select') ? 'v_multiselect'
                    :(prop.search_type === 'string') ? 'v_string'
                    :'v_none'"
                    :title="prop.title"
                    :placeholder="prop.search_type === 'string' ? prop.title : null" 
                    :options="prop.options"
                    :filterColumn="prop.filter_columns"
                    :prop="prop"
                    v-model="prop.value"
                    :class="{'last-changed': (lastChangedComponentKey === prop.key)}"
                    @change="sendFilter"
                />
            </div>
        </accordion>
        <div class="preloader" v-if="preloader"></div>
    </div>
</template>
<script>
import axios from "axios";
import accordion from './components/accordion.vue'

import v_select from 'vue_components/Select.vue'
import v_string from 'vue_components/InputContainer.vue'
import v_between from './components/between.vue'
import v_multiselect from './components/multiselect.vue'
import v_checkboxes from './components/checkboxes.vue'
export default {
    props: ['current_type_id', 'profile', 'controller_url', 'dynamic_id'],
    components: {accordion, v_string, v_select, v_between, v_multiselect, v_checkboxes},
    data() {
        return {
            properties: {},
            requestUrl: '',
            pageSort: -1,
            resultSetCount: 0,
            lastChangedComponentKey: null,
            preloader: false,
            layout: ''
        };
    },
    mounted() {
        let url  = this.profile ? '/profile/ordersFilter/' : '/catalog/itemsFilter/'
        let id_key = this.controller_url == 'selections' || this.dynamic_id ? 'dynamic_type_id' : 'type_id'
        let requestData = {}
        if(!this.profile){ requestData[id_key] = this.current_type_id }
        axios.post(url, requestData).then(res => {
            const data = res.data.data
            const search_properties = data.search_properties
            if (!Array.isArray(search_properties)) throw new Error(search_properties, 'is not array')
            search_properties.forEach(search_prop => {
                let filter_columns = search_prop.settings ? search_prop.settings.filter_columns ? search_prop.settings.filter_columns.includes('2') : false : false;
                let prop = {
                    'id': search_prop.id,
                    'key': search_prop.key,
                    'title': search_prop.filter_title ? search_prop.filter_title : search_prop.title,
                    'data_type': search_prop.data_type,
                    'search_type': search_prop.search_type,
                    'filter_columns': filter_columns,
                    options: [],
                }
                let search_values = search_prop.search_values;
                if (prop.search_type === 'between') {
                    prop.value = {'min': null, 'max': null}
                    prop.options = {'min': search_values.min, 'max': search_values.max}
                }
                if (prop.search_type === 'check') {
                    prop.value = {}
                    for (let key in search_values) {
                        let v = search_values[key]
                        prop.options.push({key: v.id, value: v.value, id: v.id})
                    }
                }
                if (prop.search_type === 'select'){
                    prop.value = -1
                    for (let key in search_values) {
                        let v = search_values[key];
                        prop.options.push({key: v.id, value: v.value, id: v.id})
                    }
                }
                if (prop.search_type === 'string') {
                    prop.value = ''
                }
                this.properties[prop.key] = prop;
            })
            this.getCurrentQueryParams();
        })
    },
    methods:{
        closeFilter() {
            this.$refs.catalogFilterEl.classList.remove('mobile-show')
            document.body.classList.remove('filter-opened')
        },
        getCurrentQueryParams(){
            let query = decodeURI(window.location.search).substring(1);
            let params = query.split(/&/);
            let urlValues = {}
            params.forEach(param => {
                const v = param.split(/([^\[\]=?&]*)(\[([^\[\]=?&]*)\])?=([^\[\]=?&]*)/g)
                const key = v[1]
                const v_key = v[3]
                const value = v[4]
                if (key === 'sort') {
                    this.pageSort = value;
                    lps.emitter.emit('interfaceSetSort', value)
                    return
                }
                if (key === 'page') return
                if (key === 'layout') {
                    this.layout = value
                    return
                }
                urlValues[key] === undefined ? urlValues[key] = [] : false
                urlValues[key].push({key, v_key, value})
            })

            for(let i in this.properties){
                let prop = this.properties[i];
                let key = prop.key;
                if (!urlValues[key]) continue
                if(prop.search_type === 'check'){
                    urlValues[key].forEach(i => {
                        let index = prop.options.findIndex(obj => obj.id == i.value)
                        if (index === -1) return
                        prop.value[index] = index
                    })
                }
                if(prop.search_type === 'between'){
                    urlValues[key].forEach(i => {
                        prop.value[i.v_key] = i.value
                    })
                }
                if(prop.search_type === 'select'){
                    prop.value = prop.options.findIndex(obj => {
                        return urlValues[key][0].value == obj.id
                    })
                }
                if (prop.search_type === 'string') {
                    prop.value = urlValues[key][0].value
                }
            }
        },
        sendFilter(){
            if (this.preloader) return
            this.preloader = true
            let url = this.profile ? '/profile/orders/' + this.buildRequestURL() : this.buildRequestURL();
            this.layout ? url += `&layout=${this.layout}` : false
            axios.get(url + '&ajax=1' )
                .then(response => {
                    this.resultSetCount = response.data.data.total_count;
                    this.requestUrl = url;
                    let newUrl = this.profile ? this.buildRequestURL() : url;
                    history.pushState(null,null, newUrl);
                    this.preloader = false
                    window.lps.emitter.emit('catalogFilterUpdate', response.data.content)
                })
                .catch(error => {console.log(error)})
        },
        buildRequestURL(){
            let result = [];
            for(let i in this.properties){
                let prop = this.properties[i];

                if(prop.search_type === 'check'){
                    for(let j in prop.value){
                        result.push(prop.key + '[]=' + prop.value[j])
                    }
                }
                if(prop.search_type === 'between'){
                    for(let j in prop.value){
                        if(typeof prop.value[j] === 'object'){
                            for(let key in prop.value[j]){
                                if(prop.value[j][key] != prop.options[key]){
                                    result.push(prop.key + '[' + key + ']=' + prop.value[j][key])
                                }
                            }
                        } else {
                            if(prop.value[j] != prop.options[j]) {
                                result.push(prop.key + '[' + j + ']=' + prop.value[j])
                            }
                        }
                    }
                }
                if(prop.search_type === 'select'){
                    if (prop.value === -1) continue
                    result.push(prop.key + '[]=' + prop.options[prop.value].id);
                }
                if(prop.search_type === 'string') {
                    if (prop.value === '') continue
                    result.push(prop.key + '[]=' + prop.value)
                }
            }
            if(this.pageSort >= 0){
                this.profile
                    ? result.push('sort='+this.pageSort)
                    : result.push('sort[price]='+this.pageSort)
            }
            return '?' + result.join('&');
        },
        resetFilter(){
            for(let i in this.properties){
                let prop = this.properties[i];
                if(prop.search_type === 'check'){
                    prop.value = {};
                }
                if(prop.search_type === 'select'){
                    prop.value = -1
                }
                if(prop.search_type === 'between'){
                    prop.value = {'min': prop.options.min, 'max': prop.options.max};
                }
                if(prop.search_type === 'string') {
                    prop.value = ''
                }
            }
            this.sendFilter()
        },
    }
}
</script>
<style lang="scss">
body {
    &.filter-opened {
        overflow: hidden;
    }
}
.checkbox-radio-showAll{
    cursor: pointer;
    font-weight: 300;
    font-size: 14px;
    line-height: 22px;
    color: #4ABAF1;
    .termi-chevron-right{
        transition: all .2s ease-in-out;
        display: inline-block;
        transform: rotate(90deg);
        vertical-align: middle;
    }
    &--open{
        .termi-chevron-right{
            transform: rotate(270deg);
        }
    }
}
.catalog-filter {
    background: #F4F9FC;
    border-radius: 5px;
    position: fixed;
    z-index: 100;
    display: none;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    &.mobile-show {
        display: block;
        overflow: hidden scroll;
    }
    &__top {
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        padding: 20px var(--container-gutter);
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #000000;
        i {
            font-size: 24px;
            color: #DEDEDE;
        }
    }
    .item {
        padding: 20px var(--container-gutter);
        border-bottom: 1px solid rgba(0, 59, 103, 0.1);
        &__top {
            display: flex;
            align-items: center;
            cursor: pointer;
        }
        &__body {
            margin-top: 22px;
        }
        &__title {
            font-size: 16px;
            line-height: 24px;
        }
        &__chevron {
            margin-left: auto;
            color: #4ABAF1;
            font-size: 24px;
            transition: .3s;
            transform: rotate(90deg);
        }
        &.toggled .item__chevron {
            transform: rotate(-90deg);
        }
        &__checkbox-radio-container {
            display: grid;
            grid-gap: 8px 50px;
        }
        &__checkbox-radio-container2 {
            display: grid;
            grid-gap: 8px;
        }
        &--reset {}
    }
    @media (min-width: 1200px) {
        display: block;
        position: relative;
        height: unset;
        &__top {
            padding: 24px 30px;
            display: none;
        }
        .item {
            padding: 24px 30px;
            &--reset {
                i {
                    display: none;
                }
            }
        }
    }
    @media (min-width: 1500px) {
        .item {
            &__checkbox-radio-container {
                grid-template-columns: 1fr 1fr;
            }
        }
    }
}
</style>